import React from 'react';
import CrowdfundingHero from '../components/CrowdfundingHero';
import ProblemSection from '../components/ProblemSection';
import SolutionSection from '../components/SolutionSection';
import StoriesOfChange from '../components/StoriesOfChange';
import DonationTiers from '../components/DonationTiers';
import TrustAndTransparency from '../components/TrustAndTransparency';
import CampaignGoal from '../components/CampaignGoal';
import FinalCTA from '../components/FinalCTA';

const CrowdfundingPage = ()=> {
  return (
    <div className="pt-16">
      {/* 1. Hero Section (Above the Fold) */}
      <CrowdfundingHero />
      
      {/* 2. The Problem */}
      <ProblemSection />
      
      {/* 3. Our Solution */}
      <SolutionSection />
      
      {/* 4. Stories of Change (Social Proof) */}
      <StoriesOfChange />
      
      {/* 5. The Ask (Donation Tiers) */}
      <DonationTiers />
      
      {/* 6. Trust & Transparency */}
      <TrustAndTransparency />
      
      {/* 7. Our Goal (Campaign Milestone) */}
      <CampaignGoal />
      
      {/* 8. Call to Action (Closing) */}
      <FinalCTA />
    </div>
  );
};

export default CrowdfundingPage;